import { Nilable } from "@shared/utils";
import { PaginadoDTO } from "@DTOS";

export class PaginadoEntidadesState<DTO> {
    protected entidades: Nilable<DTO[]>;
    protected ultimaPaginaPedida = 0;
    protected ultimaPagina = 0;
    protected total = 0;

    /**
     * Devuelve el número total de entidades.
     */
    public obtenerTotal(): number {
        return this.total;
    }

    /**
     * Devuelve las entidades
     */
    public obtenerEntidades(): DTO[] {
        return this.entidades ?? [];
    }

    /**
     * Agrega una entidad al estado
     *
     * @param entidad Entidad a agregar
     */
    public agregarEntidad(entidad: DTO) {
        if (this.entidades == null) {
            this.entidades = [];
        }
        this.entidades.push(entidad);
    }

    /**
     * Actualiza entidades guardadas
     *
     * @param callback Callback para la modificacion de entidades
     */
    public actualizarEntidades(callback: (dto: DTO) => DTO): DTO[] {
        if (this.entidades != null) {
            this.entidades = this.entidades.map(callback);
        }

        return this.obtenerEntidades();
    }

    /**
     * Devuelve la ultima pagina
     */
    public obtenerUltimaPagina(): number {
        return this.ultimaPagina;
    }

    /**
     * Carga el DTO de paginado en el state
     *
     * @param paginado DTO del paginado
     * @private
     */
    public cargarPaginado(paginado: PaginadoDTO<DTO>) {
        const entidades = this.entidades == null ? paginado.resultados : this.entidades.concat(paginado.resultados);
        const entidadesFiltrado = entidades.reduce((entidadesSinRepetidos: DTO[], entidad) => {
            const entId = Number(JSON.parse(JSON.stringify(entidad)).id);
            if (!entidadesSinRepetidos.some(elem => Number(JSON.parse(JSON.stringify(elem)).id) === entId)) {
                entidadesSinRepetidos.push(entidad);
            }
            return entidadesSinRepetidos;
        }, []);
        this.entidades = entidadesFiltrado;
        this.ultimaPagina = paginado.ultimaPagina > this.ultimaPagina ? paginado.ultimaPagina : this.ultimaPagina;
        this.ultimaPaginaPedida = paginado.pagina > this.ultimaPaginaPedida ? paginado.pagina : this.ultimaPaginaPedida;
        this.total = paginado.cantidad;
    }

    /**
     * Reinicia las entidades
     */
    public reiniciarEntidades() {
        this.entidades = null;
        this.ultimaPaginaPedida = 0;
        this.ultimaPagina = 0;
        this.total = 0;
    }
}
